/**
 * If integrationPriority is defined, returns it
 * If wwtPriority is defined, returns it
 * Otherwise, returns defaultPriority (default is -1)
 *
 * @author Ivan Shchedrovskyi
 */
export const getIntegrationOrWwtPriority = <
	T extends {
		integrationPriority?: number
		wwtPriority?: number
	}
>(
	element: T,
	defaultPriority = -1
) => {
	return element.integrationPriority ?? element.wwtPriority ?? defaultPriority
}
